import { DateSelectArg } from '@fullcalendar/react';
import { Form, Formik } from 'formik';
import React, { FC } from 'react';
import ReactModal from 'react-modal';

import { Select, SubmitBtn } from '@/components/Forms';
import Modal from '@/components/Modal';
import EmptyLegFields from '@/components/Operator/Shared/EmptyLegFields';
import MaintenanceFields from '@/components/Operator/Shared/MaintenanceFields';
import TransientFields from '@/components/Operator/Shared/TransientFields';
import { CalendarEventType } from '@/Utils/event-utils';
import { useAddEventForm } from '@/Utils/formHooks/useAddEventForm';
import useMediaQuery from '@/Utils/useMediaQuery';

interface Props {
  info?: DateSelectArg;
  modalProps: ReactModal.Props & { onRequestClose: () => void };
}

const AddEventModal: FC<Props> = ({ modalProps, info }) => {
  const isMobile = useMediaQuery('(max-width: 640px)');
  const form = useAddEventForm(modalProps.onRequestClose, info);

  return (
    <Formik {...form} enableReinitialize>
      {({ values }) => {
        const isMaintenance = values.type === 'Maintenance';
        const innerScrollStyles: React.CSSProperties = {
          overflowY: 'auto',
          overflowX: 'visible',
          maxHeight: !isMobile ? '70vh' : '60vh',
        };

        const formContent = (
          <Form className='mx-auto flex flex-col p-4 items-start'>
            <Select
              name='type'
              label='Choose an event type'
              data={CalendarEventType}
              isNotClearable
              className='m-t-30'
            />
            <div className='w-full'>
              {values.type === 'One-Way Special' ? (
                <EmptyLegFields />
              ) : values.type === 'Maintenance' ? (
                <MaintenanceFields />
              ) : values.type === 'Transient' ? (
                <TransientFields />
              ) : null}
            </div>
            <div className='w-full'>
              <SubmitBtn text='Add Event' />
            </div>
          </Form>
        );
        return (
          <Modal
            additionalStyles={{
              overflow: 'visible',
              // Keep a stable height on desktop; avoid vh quirks on Mac laptops
              height: !isMobile ? '700px' : 'auto',
              minHeight: !isMobile ? '700px' : undefined,
              maxHeight: !isMobile ? '80vh' : 'unset',
              maxWidth: !isMobile ? '60%' : undefined,
            }}
            {...modalProps}
          >
            {isMaintenance ? (
              formContent
            ) : (
              <div className='w-full h-full' style={innerScrollStyles}>
                {formContent}
              </div>
            )}
          </Modal>
        );
      }}
    </Formik>
  );
};
export default AddEventModal;
